<div class="alerts d-flex flex-column align-items-center">
    @for (alert of alerts; track alert) {
    <p>
        <shd-infobox [type]="alert.type" [headerText]="alert.text" [isDismissable]="true" [isExpanded]="false"></shd-infobox>
    </p>
    }
</div>
